import React from 'react';
import Loader from 'components/Loader/Loader';
import PublicQuestion from 'components/BriefDetailsClient/PublicQuestion/PublicQuestion';

import styles from './PublicQuestionsList.module.scss';

const PublicQuestionsList = ({
  more,
  onAnswer,
  onLoadMore,
  postingAnswers = [],
  loading = false,
  questions = [],
}) => (
  <div>
    {!loading && questions.length === 0 && (
      <div className={styles.empty}>You currently have no public questions</div>
    )}
    {questions.map((question) => (
      <PublicQuestion
        key={question.id}
        onAnswer={onAnswer}
        postingAnswer={postingAnswers.includes(question.id.toString())}
        question={question}
      />
    ))}
    <Loader className={styles.loader} loading={loading} />
    {!loading && more && (
      <em className={styles.loadMore}>
        <a onClick={() => onLoadMore()}>Load more...</a>
      </em>
    )}
  </div>
);

export default PublicQuestionsList;
